import React, { Component } from 'react';
import Submenu from './Submenu';
import { Link } from 'react-router-dom';
import Icons from '../../../common/icons/Icons';
import ChevronUp from '../../../common/icons/ChevronUp';
import ChevronDown from '../../../common/icons/ChevronDown';

class Menu extends Component {
  state = {
    openDropdown: false,
  };

  handleToggleSubmenu = () => () => {
    this.setState({
      openDropdown: !this.state.openDropdown,
    });
  };

  render() {
    const { pathname, dataMenu, dataAuth, profile } = this.props;
    const { openDropdown } = this.state;
    let url = dataMenu.alias;
    let authM = dataAuth.m;
    let authSubm = dataAuth.subm;
    const regex = new RegExp(url);
    const isActive = regex.test(pathname);
    const accessMenu = authM[dataMenu.id + '_view'];
    let rootPath = '/' + pathname.split('/').filter((e) => /\S/.test(e))[0];
    if (
      dataMenu.id === 'raporketuntasan' &&
      profile &&
      !profile.rapor_ketuntasan
    ) {
      return <></>;
    }
    if (dataMenu.id === 'raporprojek' && profile && !profile.rapor_projek) {
      return <></>;
    }
    return (
      <>
        {accessMenu && (
          <li>
            {dataMenu.subm.length === 0 && (
              <Link
                to={dataMenu.url}
                className={`disable-select custom-text-14 custom-text-overflow custom-hover-light-info${
                  rootPath === dataMenu.url ? ' is-active' : ''
                }`}
              >
                <div className='flex justify-start align-center pl-2 is-size-6'>
                  <p className='mt-1 mr-1'>
                    <Icons color={'#ffffff'} icon={dataMenu.icon} size={15} />
                  </p>
                  <p className='ml-1'>{dataMenu.title}</p>
                </div>
              </Link>
            )}
            {dataMenu.subm.length > 0 && (
              <div
                onClick={this.handleToggleSubmenu('')}
                className={`has-submenu disable-select custom-text-overflow flex justify-between custom-text-14${
                  isActive === true ? ' has-background-white-ter' : ''
                }`}
              >
                <div
                  className='has-submenu flex justify-start align-center'
                  style={{
                    paddingLeft: 4,
                  }}
                >
                  <Icons color={'#ffffff'} icon={dataMenu.icon} />
                  {dataMenu.title}
                </div>{' '}
                {openDropdown ? (
                  <ChevronUp size={15} color={'#ffffff'} />
                ) : (
                  <ChevronDown size={15} color={'#ffffff'} />
                )}
              </div>
            )}
            <ul className={openDropdown === true ? '' : 'is-hidden'}>
              {dataMenu.subm.map((subm) => (
                <Submenu
                  key={subm.id}
                  subm={subm}
                  authSubm={authSubm}
                  pathname={pathname}
                />
              ))}
            </ul>
          </li>
        )}
      </>
    );
  }
}

export default Menu;
